import { transformCheckout, type TransformedCheckoutData } from "../transformers/CartResponseTransformer";
import type { CartResponseDTO } from "../dto/CartResponseDTO";
import { resolveApiUrl } from "../../../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/checkout/multi/summary/data");

export async function getData(): Promise<TransformedCheckoutData> {
  const response = await fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  const dto: CartResponseDTO = await response.json();
  return transformCheckout(dto);
}
